import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=00d65eec&scoped=true&"
import script from "./ArticleContent.vue?vue&type=script&lang=js&"
export * from "./ArticleContent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContent.vue?vue&type=style&index=0&id=00d65eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d65eec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ForgotPasswordForm: require('/app/components/auth/ForgotPasswordForm.vue').default,CompleteAccountModal: require('/app/components/account/CompleteAccountModal.vue').default})
